import dayjs from 'dayjs';
import { capitalize as capitalizeHelper } from '@/shared/helpers/capitalize';
import { decodeHtml } from '@/shared/helpers/decode';

export const rsDateTime = (value: string | Date) => (dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD hh:mm') : (value || ''));
export const rsFullDateTime = (value: string | Date) => (dayjs(value).isValid() ? dayjs(value).format('MMMM D, YYYY, hh:mm A') : (value || ''));
export const rsMedDateTime = (value: string | Date) => (dayjs(value).isValid() ? dayjs(value).format('MMM D, YYYY, hh:mm A') : (value || ''));
export const rsDate = (value: string | Date) => (value ? dayjs(value).format('YYYY-MM-DD') : '');
export const rsFancyDate = (value: string | Date) => {
  if (value) {
    const date = dayjs(value).format('MMMM D, YYYY');
    return date;
  }

  return '';
};
export const rsFancyKey = (value: string) => (value ? capitalizeHelper(value.replace(/_|-/g, ' ')) : '');
export const rsISODateTime = (value: any) => (dayjs(value).isValid() ? dayjs(value).toISOString() : 'INVALID DATE');
export const rsUnixSecondsToDateTime = (value: any, format: string = '') => dayjs.unix(parseInt(value, 10)).format(format);
export const rsFilename = (value: string | null | undefined) => (value ? value.split(/_(.+)/)[1] : '');
export const rsFancyFilename = (value: string) => (value ? value.split('/').pop() : '');
export const rsDecodeHtml = (value: string, doubleDecode: boolean = false) => (value ? decodeHtml(value, doubleDecode) : '');
export const capitalize = (value: string) => {
  if (!value) {
    return '';
  }

  const val = value.toString();
  return val.charAt(0).toUpperCase() + val.slice(1);
};
